import { camelizeKeys } from 'humps';
import { parse } from 'query-string'; 
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Container } from 'reactstrap';
import Loading from '../../../components/Loading';
import React, { useEffect, useState } from 'react';

import config from '../../../config';
import { useDocumentTitle } from '../../../hooks';
import { WhitePanel, CardsSlider, LodgeCard, GuideCard } from '../../../components';

import { trackFlightbookingSuccess } from '../../../redux/actions/analyticsEventActions';
import api from '../../../lib/api';
import endpoints from '../../../lib/endpoints';

const goToLodges = '/lodges';
const goToGuides = '/guides';
const goToFlights = '/flights';

const getDocTitle = check => {
  if(check === null) return 'Payment Confirmation';
  return check ? 'Payment Successfull' : 'Payment Failed';
}

const SuccessMessage = () => {
  return (
    <WhitePanel>
      <h1>Payment Successful</h1>
      <hr />
      <h5><i className="icon icon-hg-checked"/> Your order has been confirmed.</h5>
      <div style={{ margin: '2% 0' }} />
      <p>
        Please check your email for the tickets and details on transportation from Kathmandu to Ramechhap and back. If you do not receive the ticket within 30 minutes, please email us at{' '}
        <a href={`mailto:${config.honeyguideEmail}`} style={{ color: '#00C0FF' }}>{config.honeyguideEmail}</a> or call / whatsapp us at{' '}
        <a href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`} style={{ color: '#00C0FF' }} rel="noopener noreferrer" target="_blank">{config.honeyguidePhoneNumber}</a>.
      </p>

      <p>
        Please also find an email with a 'HoneyGuide Credit' that you can use to{' '}
        <a href={goToLodges} style={{ color: '#00C0FF' }}>book Lodges</a>, Flights and {' '}
        <a href={goToGuides} style={{ color: '#00C0FF' }}>Guides</a> {' '}
        through Us.
      </p>

      <div className="d-flex justify-content-center">
        {' '}
        <a href={goToLodges}>
          <Button color="yellow">Continue To Lodge Booking</Button>
        </a>
      </div>
    </WhitePanel>
  )
}

const FailureMessage = () => {
  return (
    <WhitePanel>
      <h1>Payment Failed</h1>
      <hr />
      <div style={{ margin: '2% 0' }} />
      <p>
        There was some issue with the payment. Please check your bank account and try again. Or, you can contact us and we can help you book flights directly by managing an alternative payment medium.
        For any assistance, please email us at <a href={`mailto:${config.honeyguideEmail}`} style={{ color: '#00C0FF' }}>{config.honeyguideEmail}</a> or call / whatsapp us at <a href={`https://api.whatsapp.com/send?phone=${config.honeyguidePhoneNumber}`} style={{ color: '#00C0FF' }} rel="noopener noreferrer" target="_blank">{config.honeyguidePhoneNumber}</a>.
      </p>
      <div className="d-flex justify-content-center">
        <a href={goToFlights}>
          <Button>Search Another Flight</Button>
        </a>
        <a href={`mailto:${config.honeyguideEmail}`}>
          <Button color="yellow">Email Us</Button>
        </a>
      </div>
    </WhitePanel>
  )
}

function FlightBookingSuccess({ trackFlightbookingSuccess, location }) {
  const [showSuccessMessage, setShowSuccessMessage] = useState(null);
  useDocumentTitle(getDocTitle(showSuccessMessage), showSuccessMessage);
  useEffect(async () => {
    const { status, userDefined2: invoiceId } = camelizeKeys(parse(location.search));
    if (status === 'RS' || status === 'AP') {
      try {
        const { data: { invoice: { amount } } } = await api.get(endpoints.payment.getInvoice(invoiceId));
        setShowSuccessMessage(true);
        trackFlightbookingSuccess(amount);
      } catch (e) {
        console.log(e);
        setShowSuccessMessage(false);
      }
    } else {
      setShowSuccessMessage(false);
    }
  }, []);

  if(showSuccessMessage === null) return <Loading />;

  return (
    <Container>
      {
        showSuccessMessage ? SuccessMessage() : FailureMessage()
      }
      <CardsSlider
        title="Featured Lodges"
        endpoint="lodgings/lodges?is_featured=1"
        Card={LodgeCard}
      />
      <CardsSlider
        title="Featured Guides"
        endpoint="users/leaders?is_featured=1"
        Card={GuideCard}
      />
    </Container>
  );
}

const ConnectedFlightsBookingSuccess = connect(null, { trackFlightbookingSuccess })(FlightBookingSuccess);

export default withRouter(ConnectedFlightsBookingSuccess);


// WEBPACK FOOTER //
// ./src/screens/Flights/Success/SuccessScreen.js